<template>
	<a class="file-button" :href="computedLink" download @click="$emit('clicked')">
		<div class="pdf-icon">
			<img src="/img/frontend/calc/icon/pdf.svg" alt="PDF fájl" />
		</div>
		<div class="file-name">
			{{ name }}
		</div>
		<div class="download-icon">
			<img src="/img/frontend/calc/icon/arrow_down.svg" alt="Letöltés" />
		</div>
	</a>
</template>

<script>
import {mapGetters} from "vuex";
export default {
	props: {
		name: {
			type: String,
			default: null,
		},
		type: {
			type: String,
			default: 'normal',
		},
		link: {
			type: String,
			default: null,
		},
	},
	computed: {
		computedLink() {
            switch(this.type) {
                case 'normal':
                    return `/api/pdf/download/normal/${this.link}`;
                case 'insurer':
                    return `/api/pdf/download/insurer/${this.link}/${this.getCalculation.start_of_risk}`;
                case 'termination':
                    return `/api/pdf/download/generated/${this.link}/old_contract_termination_pdf`;
                case 'termination_authorization':
                    return `/api/pdf/download/generated/${this.link}/old_contract_termination_authorization_pdf`;
                default:
                    return `/api/pdf/download/generated/${this.link}/brokerage_contract_pdf`;
            }
		},
        ...mapGetters(['getCalculation']),
	},
};
</script>

<style lang="scss" scoped>
.file-button {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 180px;
	background: #fffeff;
	border-radius: 6px;
	padding: 5px 10px;
	cursor: pointer;
	transition: 0.3s;
	margin-right: 15px;
	box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
	border: 1px solid #de0a2a;

	@media screen and (max-width: 420px) {
		max-width: unset;
		width: 100%;
		margin-bottom: 10px;
	}

	&:hover {
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
	}

	.file-name {
		font-family: 'Open Sans', sans-serif;
		font-style: normal;
		font-weight: 600;
		font-size: 8px;
		line-height: 24px;
		color: #000000;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		padding-left: 10px;
		padding-right: 20px;
	}

	.download-icon {
		display: contents;

		img {
			width: 12px;
			height: 12px;
		}
	}

	.pdf-icon {
		display: contents;

		img {
			width: 30px;
			height: 30px;
		}
	}
}
</style>
